import CountryPortalTile from "../components/country-portal-tile";

const countryPortalData = [
	{
		labelText: "New",
		title: "PropTech Latam",
		labelTextClassName: "bg-green-500",
		href: "/communities/latam/home",
		logo: "https://d2psdcplj93ozo.cloudfront.net/communities/5b606cbd-bcf5-47f2-b61d-8ec6cc022eee/logo-new-project-10--1753381232691.jpg",
	},
	{
		labelText: "Hot",
		title: "PropTech India",
		labelTextClassName: "bg-red-500",
		href: "/communities/proptech-india/home",
		logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/private-discussion-boards/proptech-india/proptech-india-logo.png`,
	},
	{
		labelText: "New",
		title: "PropTech Bangladesh",
		labelTextClassName: "bg-green-500",
		href: "/communities/proptech-bangladesh/home",
		logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/private-discussion-boards/proptech-bangladesh/proptech-bangladesh-logo.png`,
	},
	{
		labelText: "New",
		title: "PropTech Germany",
		labelTextClassName: "bg-green-500",
		href: "/communities/proptech-germany/home",
		logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/private-discussion-boards/proptech-germany/proptech-germany-logo.png`,
	},
	{
		labelText: "New",
		title: "PropTech Austria",
		labelTextClassName: "bg-green-500",
		href: "/communities/proptech-austria/home",
		logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/private-discussion-boards/proptech-austria/proptech-austria-logo.png`,
	},
];

const CountryPortalsList = () => {
	return (
		<div className="mx-auto mt-12 flex w-11/12 max-w-3xl flex-wrap items-center justify-center gap-6 sm:mt-12 sm:gap-8 lg:w-full">
			{countryPortalData.slice(0, 9).map((portal, index) => (
				<CountryPortalTile
					key={index}
					id={index.toString()}
					name={portal.title}
					href={portal.href}
					logo={portal.logo || "/images/default-placeholder-image.png"}
					labelText={portal.labelText}
					labelTextClassName={portal.labelTextClassName}
				/>
			))}
		</div>
	);
};

export default CountryPortalsList;
